module.exports = __webpack_public_path__ + "static/marie_jost-3e2887a138001908e71d726b205577a5.png";